let googleMapsScriptPromise = null;

export const loadGoogleMapsApi = (apiKey, libraries = []) => {
    if (googleMapsScriptPromise) {
        return googleMapsScriptPromise;
    }

    googleMapsScriptPromise = new Promise((resolve, reject) => {
        if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
            resolve();
            return;
        }

        const script = document.createElement('script');
        const libraryParam = libraries.length ? `&libraries=${libraries.join(',')}` : '';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}${libraryParam}`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            resolve();
        };

        script.onerror = (error) => {
            reject(error);
        };

        document.head.appendChild(script);
    });

    return googleMapsScriptPromise;
};